export default "__VITE_ASSET__PP5qFQUb__"